import React, { useState } from "react";
import { Button, Form, InputGroup, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useGoogleLogin } from "./store/store";
import { toast } from "react-toastify";
import trayaLogo1 from "../../../src/assets/img/illustrations/starfleet_light.png";

function ResetPassword() {
  const { id } = useParams();
  const [passwordData, setPassword] = useState("");
  const { resetPassword } = useGoogleLogin();
  const navigate = useNavigate();

  const handleSubmit = () => {
    if (passwordData?.length) {
      resetPassword(id, { password: passwordData }, toast, navigate);
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center h-100"
      style={{ height: "100", marginTop: "15%" }}
    >
      <div>
        <div
          className="card p-2 shadow"
          style={{ width: "30rem", height: "30rem" }}
        >
          <div className="d-flex justify-content-center">
            <div className="circle-container">
              <div
                className="text-white d-flex align-items-center justify-content-center"
                style={{
                  display: "inline-block",
                  width: "150px",
                  height: "150px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  backgroundColor: "black",
                }}
              >
                <img
                  style={{ width: "8rem", filter: "brightness(0) invert(1)" }}
                  src={trayaLogo1}
                />
              </div>
            </div>
          </div>
          <h4 className="mx-4 bg-white text-danger p-2 border-bottom border-danger ">
            Pleas Enter Password
          </h4>
          <Row className="mb-3 mx-3 mt-3">
            <Form.Group md="5" controlId="exampleUserName">
              <InputGroup hasValidation>
                <Form.Control
                  name="password"
                  type="password"
                  placeholder="Password"
                  aria-label="Password"
                  aria-describedby="inputGroupPrepend"
                  onChange={(event) => setPassword(event.target.value)}
                  required
                />
                <Form.Control.Feedback
                  type="invalid"
                >
                  Please enter appropriate password.
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
          </Row>
          <Row className="text-center d-flex justify-content-around p-2">
            <Button variant="success" className="w-25" onClick={handleSubmit}>
              Submit
            </Button>
          </Row>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
